import {actions} from 'react-fields'

class LoginApi {


    static loginUser(user, saveAnswers = false) {
        const url = '/group/login';

        let data = {educator: {email: user.email, password: user.password}};


        return fetch(actions.postRequest(url, data))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }

    static resendAccountInstructions(user) {
        const url = `/group/api/sessions/${user.id}/resend_account_instructions`;
        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }

    static recoverPassword(user, onSuccess, onError) {
        const url = '/group/password';
        let data = {educator: {email: user.email}};
        return fetch(actions.postRequest(url, data))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then(  (response) => {
            onSuccess();
        }).catch(error => {
            if (error.status === 422) {
                error.json().then(function (value) {
                    onError(value);
                });
            } else {
                console.error(error);
                onError();
            }
        });
    }

    static updatePassword(user, onSuccess, onError) {
        const url = '/group/password';
        let data = { educator: {
                password: user.new_password,
                password_confirmation: user.password_confirmation || "",
                reset_password_token: user.reset_password_token
            }};

        fetch(actions.putRequest(url, data ))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then( async (response) => {
            onSuccess(response);
        }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                onError(value);
            });
        });
    }

}

export default LoginApi;